import React, { useState, useEffect, useRef } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Dialog,
    Grid,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    TextField,
    FormControl,
} from "@material-ui/core";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { DownloadOutlined, WindowsFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import { CSVLink } from "react-csv";
import HttpService from "../../services/httpService";
import DataGridComponent from "../../components/DataGridComponent";
import MenuItem from '@material-ui/core/MenuItem/MenuItem';

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 850,
    },
    textField: {
        width: 100,
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 400,
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        // backgroundColor: "#2C2E3E",
        backgroundColor: "#3F51B5",
        color: "#FFF",
        fontWeight: "500",
        // border: '1px solid black'
    },
    body: {
        fontSize: 14,
        // border: '1px solid red'
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const RaisePaymentRequest = (props) => {
    const classes = useStyles();
    const [dataForRaisingPaymentRequest, setDataForRaisingPaymentRequest] = useState([]);
    const [selectedItemsForPayment, setSelectedItemsForPayment] = useState([]);
    const [showRaisePaymentRequestModal, setShowRaisePaymentRequestModal] = useState(false);
    const [grandTotalOfRaisedRequest, setGrandTotalOfRaisedRequest] = useState(0);
    const [openRemarksModal, setOpenRemarksModal] = useState(false);
    const [grandTotalOfFreight, setGrandTotalOfFreight] = useState(0);
    const [remarks, setRemarks] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [paymentRaisedStatus, setPaymentRaisedStatus] = useState("all");
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [selectedVendor, setSelectedVendor] = useState("");
    const [vendorList, setVendorList] = useState([]);

    // Header for the Data-Grid
    const columns = [
        {
            field: "id",
            headerName: "Sl No",
            description: "Sl. No.",
            width: 70,
            editable: false,
            type: "string",
            sortable: false,
        },
        {
            field: "invoiceDate",
            headerName: "Invoice Date",
            description: "Invoice Date",
            width: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "invoiceNumber",
            headerName: "Invoice No",
            description: "Invoice No.",
            width: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "dateOfInwarded",
            headerName: "Inwarded Date",
            description: "Inwarded Date",
            width: 130,
            editable: false,
            sortable: false,
        },
        {
            field: "inwardedQty",
            headerName: "Inwarded Qty",
            description: "Inwarded Quantity",
            width: 120,
            editable: false,
            sortable: false,
        },
        {
            field: "inwardedRate",
            headerName: "Inwarded Rate",
            description: "Inwarded Rate",
            width: 130,
            editable: false,
            sortable: false,
        },
        {
            field: "gstRate",
            headerName: "GST %",
            description: "GST Rate",
            width: 100,
            editable: false,
            sortable: false,
        },
        // {field: "inwardedValue", headerName: "Inwarded Value", width: 100},
        {
            field: "inwardedValue",
            // headerName: "Inwd Value",
            headerName: "Inwarded Value",
            width: 130,
            // width: 100,
            description: "Inwarded Qty x Inwarded Rate (With GST)",
            editable: false,
            sortable: false,
            // valueGetter: (params) =>
            //     `${+params.getValue(params.id, "inwardedQty") *
            //     +params.getValue(params.id, "inwardedRate")
            //     }`,
        },
        {
            field: "inwardingId",
            headerName: "Inwarding Id",
            description: "Inwarding Id",
            width: 160,
            editable: false,
            type: "string",
            sortable: false,
        },
        /*
        {
            field: "vendorName",
            headerName: "Vendor Name",
            width: 120,
            editable: false,
            sortable: false,
        },
        */
        {
            field: "materialName",
            headerName: "Material Name",
            description: "Material Name",
            width: 150,
            editable: false,
            sortable: false,
        },
    ];

    // Headers to for csv
    const headers = [
        { key: "orderId", label: "PO No." },
        { key: "inwardingId", label: "Inwarding Id" },
        { key: "dateOfInwarded", label: "Inwarded Date" },
        { key: "invoiceDate", label: "Invoice Date" },
        { key: "invoiceNumber", label: "Invoice N0" },
        { key: "inwardedRate", label: "Inwarded Rate" },
        { key: "inwardedQty", label: "Inwarded Qty" },
        { key: "gst", label: "GST" },
        { key: "freightCharges", label: "Freight Charge" },
        { key: "totalValue", label: "Total Value" },
    ];

    // Function to get inwarding approved by finance to Raise Payment Requests
    const fetchInwardingApprovedForPaymentRequests = async (startDate, endDate, paymentRaisedStatus, vendorId) => {
        props.setLoading(true);
        try {
            let payload = { startDate, endDate, paymentRaisedStatus, vendorId };
            const response = await HttpService.fetchInwardingApprovedForPaymentRequests(payload);
            let resData = [];
            setDataForRaisingPaymentRequest(response.data);
            // setDataToDisplay(response.data);
        } catch (error) {
            console.error("Error -> ", error);
            props.setSnackInfo(
                error?.response?.data ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // Function to handle the selected inwarding for payment
    const handleSelectedInwardingChange = (selectedInwardingArr) => {
        // Set loading state to true while processing
        props.setLoading(true);

        try {
            // Create a copy of the current selected items
            let prevArray = [...selectedItemsForPayment];

            // Filter out items from prevArray that are not in selectedInwardingArr
            let newArray = prevArray.filter(el => {
                return !selectedInwardingArr.some(item => item.inwardingRecordId.toString() === el.inwardingRecordId.toString());
            });

            // Add items from selectedInwardingArr that are checked
            selectedInwardingArr.forEach(el => {
                if (el.isChecked) {
                    newArray.push(el);
                }
            });

            // Log the total number of selected items

            // Update the state with the new selected items
            setSelectedItemsForPayment(newArray);
        } catch (error) {
            console.error("Error -> ", error);
        }

        // Set loading state to false after processing
        props.setLoading(false);
    };

    // Function to open the raised payment request modal 
    const openRaisePaymentRequestModal = () => {
        props.setLoading(true);
        try {
            if (selectedItemsForPayment.length === 0) {
                props.setSnackInfo("No items selected. Please select at least one item to raise a payment request.", "warning");
                props.setLoading(false);
                return;
            }
            setShowRaisePaymentRequestModal(true);
            // const total = selectedItemsForPayment.reduce((acc, el) => acc + (+el.inwardedQty * +el.inwardedRate), 0);
            const total = selectedItemsForPayment.reduce((acc, el) => acc + (+el?.inwardedValue || 0), 0);
            const totalFreight = selectedItemsForPayment.reduce((acc, el) => acc + (+el?.freightCharge || 0), 0);
            setGrandTotalOfRaisedRequest(total);
            setGrandTotalOfFreight(totalFreight);
        } catch (error) {
            console.error("Error - ", error);
        }
        props.setLoading(false);
    }

    // Function to handle the raise payment request action
    const raisePaymentRequestHandler = async () => {
        props.setLoading(true);
        setOpenRemarksModal(false);
        try {
            let selectedItemsForPaymentIds = selectedItemsForPayment.map((el) => el.inwardingRecordId);
            let payload = { selectedItemsForPaymentIds, grandTotalOfRaisedRequest, grandTotalOfFreight };
            const response = await HttpService.raisePaymentRequestsForInwarding(payload);
            props.setSnackInfo(response?.data?.msg ?? "Updated Successfully", response?.data?.type ?? "success");
        } catch (error) {
            console.error("Error-- ", error);
        }
        setShowRaisePaymentRequestModal(false);
        props.setLoading(false);
        fetchInwardingApprovedForPaymentRequests("", "", "all", "");
        window.location.reload();
    }

    // Function to Open Remarks Modal
    const openRemarksModalHandler = () => {
        setOpenRemarksModal(true);
    };

    // function to format date
    const dateFormatter = (inputDate) => {
        if (inputDate === "") return "N/A";
        const date = new Date(inputDate);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        const formattedDay = day < 10 ? "0" + day : day;
        const formattedMonth = month < 10 ? "0" + month : month;

        const formattedDate = formattedDay + "-" + formattedMonth + "-" + year;
        return formattedDate;
    };

    // Funtion to close Remarks Modal
    const closeRemarksModalHandler = () => {
        setOpenRemarksModal(false);
        setRemarks("");
    };

    // Function to handle remarks input
    const remarksInputHandler = async (e) => {
        setRemarks(e.target.value);
        // if (e.target.value.trim() === "") return props.setSnackInfo("Please Enter Remarks", "error");
    };

    // function to clear date filter
    const clearFilterDate = (e) => {
        setStartDate("");
        setEndDate("");
        setPaymentRaisedStatus("all");
        setSelectedVendor("");
        fetchInwardingApprovedForPaymentRequests("", "", "all", "");
    };

    // filter function for date range
    const inwardedDataOnSelectedDateHandler = () => {
        fetchInwardingApprovedForPaymentRequests(startDate, endDate, paymentRaisedStatus, selectedVendor?._id);
    };

    // function to download data in csv
    const csvDownloadHandler = async () => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < dataForRaisingPaymentRequest.length; i++) {
                let el = dataForRaisingPaymentRequest[i];
                for (let j = 0; j < el.InwardingRecordArr.length; j++) {
                    let obj = {
                        orderId: el?.orderId || "N/A",
                        inwardingId: el?.InwardingRecordArr[j]?.inwardingId || "N/A",
                        dateOfInwarded: el?.InwardingRecordArr[j]?.dateOfInwarded,
                        invoiceDate: el?.InwardingRecordArr[j]?.invoiceDate,
                        invoiceNumber: el?.InwardingRecordArr[j]?.invoiceNumber,
                        inwardedRate: el?.InwardingRecordArr[j]?.inwardedRate?.toFixed(2),
                        inwardedQty: el?.InwardingRecordArr[j]?.inwardedQty?.toFixed(2),
                        gst: el?.InwardingRecordArr[j]?.gstRate?.toFixed(2),
                        freightCharges: el?.InwardingRecordArr[j]?.freightCharge,
                        totalValue: (+el?.InwardingRecordArr[j]?.inwardedValue + (+el?.InwardingRecordArr[j]?.freightCharge || 0))?.toFixed(2),
                    };
                    csvArray.push(obj);
                    /*
                    obj = {
                        orderId: "",
                        inwardingId: "",
                        inwardedDate: "",
                        invoiceDate: "",
                        invoiceNumber: "",
                        poQty: "",
                        inwardedQty: "",
                        gst: "",
                        freightCharges: "",
                        totalValue: "",
                    };
                    csvArray.push(obj);
                    */
                }


            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.error("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    // a helper function for csv download
    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    // function to handle the payment status change
    const handlePaymentStatusChange = (event) => {
        try {
            setPaymentRaisedStatus(event.target.value);
            // fetchInwardingApprovedForPaymentRequests(startDate, endDate, event.target.value);
        } catch (error) {
            console.error("Error -> ", error);
        }
    }

    // fucntion to get all vendor's list
    const fetchAllVendorHandler = async () => {
        try {
            const response = await HttpService.getAllVendors();
            setVendorList(response.data);
        } catch (error) {
            console.error("Error -> ", error);
            props.setSnackInfo("Something Went Wrong", "error");
        }
    }

    // function to handle vendor select
    const handleVendorChange = async (event, value) => {
        try {
            setSelectedVendor(value);
        } catch (error) {
            console.error("Error -> ", error);
            props.setSnackInfo("Something Went Wrong", "error");
        }
    }

    useEffect(() => {
        fetchAllVendorHandler();
        fetchInwardingApprovedForPaymentRequests(startDate, endDate, paymentRaisedStatus, selectedVendor?._id);
    }, []);

    return (
        <div>
            <div
                style={{
                    marginBottom: 20,
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Paper className={classes.paper}>
                    <center>
                        <h2>Raise Payment Request</h2>
                    </center>
                </Paper>
            </div>

            {/* Vendor And Payment Status Filter component */}
            <Paper style={{ padding: 10, marginBottom: 10 }}>
                <Grid container style={{ display: "flex", alignItems: "center" }}>
                    {/* Payment Status Field */}
                    <Grid item xs={12} sm={3}>
                        <FormControl style={{ width: '100%', marginTop: "0.4rem" }}>
                            <TextField
                                select
                                labelId="project-doc"
                                label="Payment Status"
                                variant="outlined"
                                value={paymentRaisedStatus}
                                onChange={(e) => handlePaymentStatusChange(e)}
                            >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="true">Raised</MenuItem>
                                <MenuItem value="false">Not-Raised</MenuItem>
                            </TextField>
                        </FormControl>
                    </Grid>
                    {/* Select Vendor Button */}
                    <Autocomplete
                        value={selectedVendor}
                        onChange={handleVendorChange}
                        id="vendor-name-dropdown"
                        options={vendorList}
                        getOptionLabel={(option) => option.name}
                        style={{ width: 500, margin:10 }}
                        renderInput={(params) => <TextField {...params} label="Vendor Search" fullWidth variant="outlined" />}
                    />
                    {/* Download CSV Button */}
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <CSVLink
                            headers={headers}
                            filename={"Inwarding Payment Excel " + new Date().toLocaleDateString().replaceAll("/", "_") + ".csv"}
                            data={csvData}
                            ref={csvButtonRef}
                        />
                        <Button
                            onClick={csvDownloadHandler}
                            style={{ margin: 10, backgroundColor: "green" }}
                            variant="contained"
                            color="success"
                        >
                            Download CSV
                        </Button>
                    </div>
                </Grid>
            </Paper>
            
            {/* Date Filter component */}
            <Paper style={{ padding: 10, marginBottom: 10 }}>
                <Grid container style={{ display: "flex", alignItems: "center" }}>
                    {/* Start Date */}
                    <Grid item md={3} xs={12}>
                        <TextField
                            id="date"
                            name="startDate"
                            label="From Inwarded Date"
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            fullWidth
                        // className={classes.textField}
                        />
                    </Grid>
                    <Grid item md={1} xs={12}></Grid>
                    {/* End Date */}
                    <Grid item md={3} xs={12}>
                        <TextField
                            id="date"
                            name="endDate"
                            label="To Inwarded Date"
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            fullWidth
                        // className={classes.textField}
                        />
                    </Grid>
                    {/* Submit Button */}
                    <Grid item md={3} xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            // disabled={!startDate || !endDate}
                            onClick={inwardedDataOnSelectedDateHandler}
                            style={{ marginLeft: 10 }}
                        >
                            Submit
                        </Button>
                    </Grid>
                    {/* Filter Button */}
                    <Grid item md={2} xs={12}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={clearFilterDate}
                        >
                            Clear Filter
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            {dataForRaisingPaymentRequest.map((el, i) => {
                return (
                    <DataGridComponent
                        key={i + 1}
                        INWARDING_RECORD_ARRAY={el.InwardingRecordArr}
                        COLUMNS={columns}
                        ORDER_ID={el.orderId}
                        VENDOR_NAME={el.vendorName}
                        PAGE_SIZE={el.InwardingRecordArr.length}
                        HANDLE_SELECTED_INWARDING_CHANGE={
                            handleSelectedInwardingChange
                        }
                    />
                );
            })}

            {/*
            <TableContainer TableContainer component={Paper}>
                <Table
                    className={classes.table}
                    size="small"
                    aria-label="customized table"
                    stickyHeader
                >
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell>Sl No</StyledTableCell>
                            <StyledTableCell>PO/SO/MTR NO</StyledTableCell>
                            <StyledTableCell>Inwarding Id</StyledTableCell>
                            <StyledTableCell>Vendor Name</StyledTableCell>
                            <StyledTableCell>BOM Qty</StyledTableCell>
                            <StyledTableCell>Std Rate</StyledTableCell>
                            <StyledTableCell>BOM Value</StyledTableCell>
                            <StyledTableCell>PO Qty</StyledTableCell>
                            <StyledTableCell>PO Rate</StyledTableCell>
                            <StyledTableCell>Po value</StyledTableCell>
                            <StyledTableCell>Date Of Inwarding</StyledTableCell>
                            <StyledTableCell>Inwarded Qty</StyledTableCell>
                            <StyledTableCell>Rate</StyledTableCell>
                            <StyledTableCell>Inwarding Value</StyledTableCell>
                            <StyledTableCell>Approved Qty</StyledTableCell>
                            <StyledTableCell>Approved rate</StyledTableCell>
                            <StyledTableCell>Approved Value</StyledTableCell>
                            <StyledTableCell> Action </StyledTableCell>
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {dataForRaisingPaymentRequest?.map((el, i) => {
                            return (
                                <StyledTableRow key={i + 1}>
                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                    <StyledTableCell>
                                        {el?.procurementId?.orderId}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardingId || "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.vendorId?.name}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.bomQuantity?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.bomStandardRate?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>{el?.bomValue?.toFixed(2)}</StyledTableCell>
                                    <StyledTableCell>
                                        {el?.poQuantity?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.poStandardRate?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>{el?.poValue?.toFixed(2)}</StyledTableCell>
                                    <StyledTableCell>
                                        {moment(el?.InwardingRecords?.dateOfInwarded).format(
                                            "DD-MM-YYYY"
                                        )}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardedQty?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardedRate?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardedValue?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.approvedQty?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.approvedRate?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.approvedValue?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                // onClick={() => openInvoiceModalHandler(el)}
                                            >
                                                Action
                                            </Button>
                                        </>
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            */}

            {/* Payment Request Summary */}
            <Modal
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                title={`Payment Request Summary`}
                centered
                open={showRaisePaymentRequestModal}
                onCancel={() => setShowRaisePaymentRequestModal(false)}
                width={1500}
                maskClosable={true}
                footer={null}
            >
                <div style={{ display: "flex", width: "100%" }}>
                    <Table size="small" aria-label="custom pagination table" className={classes.table}>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell>SL No</StyledTableCell>
                                <StyledTableCell>Vendor’s Name</StyledTableCell>
                                <StyledTableCell>Order Id</StyledTableCell>
                                <StyledTableCell>Material’s Name</StyledTableCell>
                                <StyledTableCell>In-warded Date</StyledTableCell>
                                <StyledTableCell>Amount (With GST)</StyledTableCell>
                                <StyledTableCell>Freight</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>

                        <TableBody>
                            {selectedItemsForPayment?.map((item, index) => (
                                <StyledTableRow key={index}>
                                    <StyledTableCell>{index + 1}</StyledTableCell>
                                    <StyledTableCell>
                                        {item?.vendorName}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {item?.orderId}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {item?.materialName}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {item?.dateOfInwarded}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {item?.inwardedValue}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {item?.freightCharge}
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                            <StyledTableRow key={"Total Amount"}>
                                <StyledTableCell colSpan={2}></StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                                <StyledTableCell><b>{grandTotalOfRaisedRequest?.toFixed(2)}</b></StyledTableCell>
                                <StyledTableCell><b>{grandTotalOfFreight?.toFixed(2)}</b></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow key={"Grand Total Amount"}>
                                <StyledTableCell colSpan={2}><b>Total Amount</b></StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                                <StyledTableCell><b>{(grandTotalOfRaisedRequest + grandTotalOfFreight).toFixed(2)}</b></StyledTableCell>
                            </StyledTableRow>
                        </TableBody>
                    </Table>
                </div>
                {/*
                <div>
                    <Table>
                        <TableBody>
                            <TableRow key="1">
                                <StyledTableCell>Total Amount</StyledTableCell>
                                <StyledTableCell>{grandTotalOfRaisedRequest}</StyledTableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
                */}

                <DialogActions>
                    <Button
                        onClick={() => setShowRaisePaymentRequestModal(false)}
                        color="secondary"
                        variant="outlined"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={openRemarksModalHandler}
                        color="primary"
                        variant="contained"
                        style={{ background: "#2b7636", margin: 5 }}
                    >
                        Raise Payment Request
                    </Button>
                </DialogActions>
            </Modal>

            {/* Payment Raised Request Confirmation Dialog Box */}
            <div>
                <Dialog
                    open={openRemarksModal}
                    onClose={closeRemarksModalHandler}
                    aria-labelledby="form-dialog-title"
                    maxWidth="xs"
                    // maxWidth="sm"
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText><b style={{ color: "red" }}>Confirmation!</b></DialogContentText>
                        <DialogContentText>Are you sure you want to raise payment requests for the selected item(s)?</DialogContentText>
                    </DialogContent>
                    {/*
                    <DialogContent>
                        <DialogContentText>Enter {textContent} Remarks</DialogContentText>
                        <TextField
                            id="remarks"
                            name="Remarks"
                            label="Add Remarks"
                            variant="outlined"
                            type="text"
                            value={remarks}
                            onChange={remarksInputHandler}
                            fullWidth
                        />
                    </DialogContent>
                    */}
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={closeRemarksModalHandler}
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={raisePaymentRequestHandler}
                            variant="contained"
                            color="primary"
                            style={{ background: "#2b7636", margin: 5 }}
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>

            {/* Raise Payment Request Button */}
            <Button
                onClick={openRaisePaymentRequestModal}
                variant="contained"
                color="primary"
                style={{ background: "#2b7636", margin: 5 }}
            >
                Raise Payment
            </Button>
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(
    RaisePaymentRequest
);